"use strict";

exports.__esModule = true;
exports.default = FilePreviewAndLink;
var _preact = require("preact");
var _FilePreview = _interopRequireDefault(require("../../FilePreview.js"));
var _MetaErrorMessage = _interopRequireDefault(require("../MetaErrorMessage.js"));
var _getFileTypeIcon = _interopRequireDefault(require("../../../utils/getFileTypeIcon.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function FilePreviewAndLink(props) {
  var file = props.file,
    i18n = props.i18n,
    toggleFileCard = props.toggleFileCard,
    metaFields = props.metaFields,
    showLinkToFileUploadResult = props.showLinkToFileUploadResult;
  var white = 'rgba(255, 255, 255, 0.5)';
  var previewBackgroundColor = file.preview ? white : (0, _getFileTypeIcon.default)(file.type).color;
  return (0, _preact.h)("div", {
    className: "uppy-Dashboard-Item-previewInnerWrap",
    style: {
      backgroundColor: previewBackgroundColor
    }
  }, showLinkToFileUploadResult && file.uploadURL && (0, _preact.h)("a", {
    className: "uppy-Dashboard-Item-previewLink",
    href: file.uploadURL,
    rel: "noreferrer noopener",
    target: "_blank",
    "aria-label": file.meta.name
  }, (0, _preact.h)("span", {
    hidden: true
  }, file.meta.name)), (0, _preact.h)(_FilePreview.default, {
    file: file
  }), (0, _preact.h)(_MetaErrorMessage.default, {
    file: file,
    i18n: i18n,
    toggleFileCard: toggleFileCard,
    metaFields: metaFields
  }));
}